import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import handImage from "../images/hand.png";
import footImage from "../images/foot.png";
import handfootImage from "../images/handfoot.png";

const useStyles = makeStyles({
  root: {
    width: 300,
  },
  media: {
    height: 150,
  },
});

export default function MediaCard(props) {
  const classes = useStyles();
  let peripheralData = {};
  switch (props.peripheralType) {
    case "hand":
      peripheralData = {
        title: "Motus Hand",
        subtitle: "",
        price: props.telehealth
          ? ""
          : "",
        image: handImage,
      };
      break;
    case "foot":
      peripheralData = {
        title: "Motus Foot",
        subtitle: "",
        price: props.telehealth
          ? ""
          : "",
        image: footImage,
      };
      break;
    case "handfoot":
      peripheralData = {
        title: "Motus Hand & Foot",
        subtitle: "",
        price: props.telehealth
          ? ""
          : "",
        image: handfootImage,
      };
      break;
    default:
      break;
  }

  return (
    <Card className={classes.root}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={peripheralData.image}
          title={peripheralData.title}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2" align="center">
            {peripheralData.title}
          </Typography>
          <Typography gutterBottom variant="h6" align="center">
            {peripheralData.subtitle}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="div">
            <ul>
              {props.telehealth ? (
                <li>Weekly PT/OT Telehealth Sessions</li>
              ) : (
                <li>Personalized Therapy</li>
              )}
              <li>Personlized Reports</li>
              <li>Clinical Support</li>
              <li>Technical Support</li>
              <li>Software Updates</li>
              <li>{peripheralData.price}</li>
            </ul>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
